import { render, staticRenderFns } from "./InventoryCsvDownload.vue?vue&type=template&id=65210396&"
import script from "./InventoryCsvDownload.vue?vue&type=script&lang=js&"
export * from "./InventoryCsvDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports